var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-text-area',_vm._g(_vm._b({staticClass:"mb-4",attrs:{"value":_vm.value,"label":_vm.field.title,"rules":_vm.rules,"required":_vm.required,"counter":_vm.getMaxLength}},'app-text-area',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }